// models/produtos/Variacao.js

export class Variacao {
    constructor(id = 0, descricao = '', variacaoItens = [], dataExclusao = null) {
        this.id = id;
        this.descricao = descricao;
        this.variacaoItens = variacaoItens;
        this.dataExclusao = dataExclusao;
    }
}
